import { render } from "./Regular.vue?vue&type=template&id=6a473b70&scoped=true&ts=true"
import script from "./Regular.vue?vue&type=script&lang=ts"
export * from "./Regular.vue?vue&type=script&lang=ts"

import "./Regular.vue?vue&type=style&index=0&id=6a473b70&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a473b70"]])

export default __exports__